import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var ArticleDescription = styled.div.withConfig({
  displayName: "Headings__ArticleDescription",
  componentId: "sc-jlzzgc-0"
})(["", " margin-top:12px;color:", ";ul{padding-left:12px;li:before{display:inline-block;margin-right:6px;content:'\u2022';vertical-align:sub;font-size:36px;line-height:1;color:", ";}}a{color:", ";}", " ", " ", ""], getFont(0), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.fontL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.linkColor;
}, function (_ref4) {
  var $variantId = _ref4.$variantId;
  return $variantId === 'small' && css(["", ""], getFont(-1, 'compact'));
}, maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["display: none;"]))), maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["display: block;"]))));
export var Title = styled.h2.withConfig({
  displayName: "Headings__Title",
  componentId: "sc-jlzzgc-1"
})(["display:block;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;color:", ";", " ", " ", " &:hover{text-decoration:underline;}"], function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.cardsTitleColor);
}, function (_ref6) {
  var $fontSize = _ref6.$fontSize,
    $compact = _ref6.$compact;
  return $fontSize ? "".concat(getFont($fontSize - ($compact ? 1 : 0), 'compact'), ";") : '';
}, function (_ref7) {
  var _ref7$$fontWeight = _ref7.$fontWeight,
    $fontWeight = _ref7$$fontWeight === void 0 ? 700 : _ref7$$fontWeight;
  return $fontWeight ? "font-weight: ".concat($fontWeight, ";") : '';
}, function (_ref8) {
  var $withTopMargin = _ref8.$withTopMargin;
  return $withTopMargin ? 'margin-top: 4px;' : '';
});
export var Subtitle = styled.h3.withConfig({
  displayName: "Headings__Subtitle",
  componentId: "sc-jlzzgc-2"
})(["display:block;color:", ";", ";", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return "".concat(theme.cardsSubtitleColor);
}, textEllipsis, getFont(0, 'compact'));
export var VideoMeta = styled.div.withConfig({
  displayName: "Headings__VideoMeta",
  componentId: "sc-jlzzgc-3"
})(["margin-top:6px;color:", ";", ";", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.terciary;
}, textEllipsis, getFont(-1, 'compact'));